import {Route, Switch} from 'react-router-dom';
import {CouponsCheckout} from '../../couponsCheckout/CouponsCheckout';
import {CouponsCheckoutThankYou} from '../../couponsCheckout/CouponsCheckoutThankYou/CouponsCheckoutThankYou';
export const COUPON_ROUTES_PREFIX = '/coupon';
export const COUPON_ROUTES = {
  COUPON_CHECKOUT: `${COUPON_ROUTES_PREFIX}`,
  COUPONS_THANK_YOU: `${COUPON_ROUTES_PREFIX}/thank-you`,
};

export const CouponRoutes = () => {
  return (
    <Switch>
      <Route
        path={COUPON_ROUTES.COUPON_CHECKOUT}
        exact={true}
        component={CouponsCheckout}
      />
      <Route
        path={COUPON_ROUTES.COUPONS_THANK_YOU}
        exact={true}
        component={CouponsCheckoutThankYou}
      />
    </Switch>
  );
};
